import React from 'react';
import SupportPromptGroup from '@cloudscape-design/chat-components/support-prompt-group';
import type {UIMessage} from 'ai';

interface SuggestedMessagesProps {
    messages: UIMessage[];
    onSelect: (text: string) => void;
}

export default function SuggestedMessages({messages, onSelect}: SuggestedMessagesProps) {
    const lastMessage = messages[messages.length - 1];
    if (!lastMessage) return null;

    const suggestionPart = [...lastMessage.parts].reverse().find((p) => (p as any).type === 'data-suggestions') as
        | {type: 'data-suggestions'; data: string[]}
        | undefined;

    if (!suggestionPart?.data?.length) return null;

    const items = suggestionPart.data.map((text, i) => ({id: `${i}`, text}));

    return (
        <div style={{paddingLeft: 32, paddingTop: 8}}>
            <SupportPromptGroup
                items={items}
                onItemClick={(e) => onSelect(items[+e.detail.id].text)}
                ariaLabel="Suggested messages"
                alignment="horizontal"
            />
        </div>
    );
}
